import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  styledText: {
    display: 'block',
    lineHeight: 1.3
  },
  verifyBtn: {
    height: 30,
    width: 80
  },
  UWContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center'
  },
  title: {
    fontSize: 16,
    color: theme.colorPalette.white
  },
  boldButton: {
    minWidth: 160,
    fontSize: 16,
    fontWeight: 600
  },
  bannerTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600
  }
}));

export default useStyles;
